/**
 * Module-level unread badge bus for the mobile Chat tab.
 * Mirrored after `src/player/reward-notifications.ts`.
 */

type Listener = () => void;

let unreadCount = 0;
let version = 0;
const listeners = new Set<Listener>();

function notify(): void {
  version += 1;
  for (const listener of listeners) listener();
}

export function setChatUnreadCount(count: number): void {
  const next = Math.max(0, Math.floor(count));
  if (next === unreadCount) return;
  unreadCount = next;
  notify();
}

export function getChatUnreadCount(): number {
  return unreadCount;
}

export function getChatUnreadVersion(): number {
  return version;
}

export function subscribeChatUnread(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Test helper. */
export function resetChatUnreadStore(): void {
  unreadCount = 0;
  version = 0;
  notify();
}
